var $ = require('jquery');
var scrollMonitor = require("scrollMonitor");


// sticky nav

$(window).on('load', function () {

    var primaryNav = $('.site-header__primary-nav'),
        primaryNavWidth,
        primaryNavHeight,
        primaryNavLeft,
        siteHeader = $('.site-header'),
        siteHeaderHeight;

    function stick() {
        primaryNav.addClass('site-header__primary-nav--is-sticky');
        primaryNav.width(primaryNavWidth);
        primaryNav.css('left', primaryNavLeft);
    }

    function unstick() {
        primaryNav.removeClass('site-header__primary-nav--is-sticky');
        primaryNav.width('');
        primaryNav.css('left', '');
    }

    $(window).on('resize', function () {

        // unstick first so we get accurate dimentions and positioning
        unstick();

        siteHeaderHeight = siteHeader.height();
        primaryNavHeight = primaryNav.height();
        primaryNavWidth = primaryNav.width();
        var primaryNavOffset = primaryNav.offset();
        primaryNavLeft = primaryNavOffset.left;

        var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollPosition > (siteHeaderHeight - (primaryNavHeight / 2))) {
            stick();
        } else {
            unstick();
        }

    }).resize();

    $(window).on('scroll', function () {

        var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollPosition > (siteHeaderHeight - (primaryNavHeight / 2))) {
            stick();
        } else {
            unstick();
        }
    });
});


// fitvids

let fitvids = require('fitvids');
fitvids('.basic-content');


// match height

require('jquery-match-height');
$('.stats__stat').matchHeight();


// count up

let CountUp = require('countup.js');

$('.stats__stats').each(function () {

    var elementWatcher = scrollMonitor.create( this );
    elementWatcher.enterViewport(function() {

        $(this.watchItem).find('.stats__stat-number').each(function (i, elm) {

            elementWatcher.destroy();

            var separator = '',
                suffix = '',
                number = $(elm).text();
            if (number.indexOf(',') > -1) {
                separator = ',';
                number = number.replace(/,/g, '');
            } else if (number.indexOf('%') > -1) {
                suffix = '%';
                number = number.replace(/%/g, '');
            }

            var countAnimation = new CountUp(elm, 0, number, 0, 2, {
                'separator': separator,
                'suffix': suffix
            });
            if (!countAnimation.error) {
                countAnimation.start();
            } else {
                console.error(countAnimation.error);
            }
        });

    });
});


// hero slide transition

var heroSlides = $('.hero__slide');

if (heroSlides.length > 0) {
    heroSlides.eq(0).addClass('hero__slide--active');
}

if (heroSlides.length > 1) {

    function slideTransition() {
        var activeSlide = $('.hero__slide--active');
        var nextSlide = activeSlide.next('.hero__slide');
        if ( !nextSlide.length ) {
            nextSlide = heroSlides.eq(0);
        }

        activeSlide.removeClass('hero__slide--active');
        nextSlide.addClass('hero__slide--active');

        setTimeout(slideTransition, 6000);
    }

    setTimeout(slideTransition, 5000);
}


// mobile nav

$('.site-header__mobile-nav-opener a').on('click', function (e) {
    e.preventDefault();
    $('body').addClass('body--mobile-nav-active');
});
$('.site-header__mobile-nav-closer a').on('click', function (e) {
    e.preventDefault();
    $('body').removeClass('body--mobile-nav-active');
});


// sharing popups

$('a.popup').on('click', function (e) {
    e.preventDefault();
    objWindow = window.open($(this).attr('href'), $(this).attr('title'), 'height=400,width=500').focus();
});

// new tab from links
$('a[href^="htt"]').each(function () {
    var a = new RegExp("wearetheusmma.com");
    var b = new RegExp("/" + window.location.hostname + "/");
    if (!a.test(this.href) && !b.test(this.href)) {
        $(this).on("click", function (e) {
            event.preventDefault();
            event.stopPropagation();
            window.open(this.href, "_blank");
        });
    }
});